import "./Workshift.scss";

import React from "react";
import { inject, observer } from "mobx-react";
import { RouteNode } from "react-router5";

import Frame from "../Frame/Frame";
import Popup from "../../Components/Popup/Popup";
import Select from "react-select";
import { SelectStyle, DropdownIndicator } from "../App/select_style";
import { STORE_CONFIG } from "../../Store/ConfigStore";
import { ROUTE_WORKSHIFT, ROUTE_MAP } from "../../routes";
import { STORE_WORKSHIFT } from "../../Store/WorkshiftStore";
import axios from "axios";
import DatePicker, { registerLocale } from "react-datepicker";
import hu from "date-fns/locale/hu";
registerLocale("hu", hu);
import { formatDate, formatDateOnly } from "../../utility";
import { timeout } from "q";
import XLSX from "xlsx";

const Search = inject((stores) => ({
  store: stores.store.get(STORE_WORKSHIFT),
}))(
  observer((props) => {
    const { store } = props;
    const cancelClassname =
      "search-cancel-button" + (store.search.length > 0 ? "" : " hidden");
    return (
      <div className="eventlogs-search">
        <div className="eventlogs-search__label">Keresés</div>
        {/*<div className="table-search__input-container">      
        <input className="form-input form-input--inline" type="text" name="focus" value={store.search} onChange={e => store.setSearch(e.target.value)} />       
    </div>*/}
        <div className="search-wrapper">
          <input
            className="search-input"
            value={store.search}
            onChange={(e) => store.setSearch(e.target.value)}
          />
          <div className={cancelClassname} onClick={(e) => store.setSearch("")}>
            <i className="fas fa-times"></i>
          </div>
        </div>
      </div>
    );
  })
);

@inject((stores) => ({
  store: stores.store.get(STORE_WORKSHIFT),
  configStore: stores.store.get(STORE_CONFIG),
  socket: stores.socket,
  router: stores.router,
}))
@observer
class Workshift extends React.Component {
  constructor(props) {
    super(props);

    const { store, configStore } = this.props;

    store.setDate(new Date());
    store.setWorkshift({
      value: configStore.workshifts[0],
      label: configStore.workshifts[0],
    });
  }

  componentDidMount() {
    this.refresh();
  }

  refresh() {
    const { store, socket } = this.props;

    const date = new Date(store.date);
    const workshift = store.workshift.value.split(" - ");
    const from = new Date(date.setHours(workshift[0], 0, 0));
    let to = new Date(date.setHours(workshift[1], 0, 0));
    if (workshift[1] === "02" || workshift[1] === "06")
      to = to.setDate(to.getDate() + 1);
    const data = {
      From: formatDate(from),
      To: formatDate(to),
    };

    socket.emitWithToken("GetEventlogs", data, function (err, data) {
      if (err) {
        console.error(err);
        return;
      }
      store.setItems(data);
    });
  }

  handleDownload() {
    const { store } = this.props;

    const merges = [];
    const data = [
      [
        "Időpont",
        "Felhasználó",
        "Művelet",
        "Azonosító",
        "Gép",
        "Fok",
        "Cikk",
        "Mennyiség",
        "Összmennyiség",
        "Beszállító",
      ],
    ];
    let rowindex = 1;

    this.props.store.shownItems.forEach((log) => {
      const details = log.Details;
      data.push([
        log.Timestamp.split(" ")[1],
        log.UserName,
        details.Operation,
        details.LotNo + (details.SealNum ? " (" + details.SealNum + ")" : ""),
        details.Machine ? details.Machine + " x " + details.CleaningCount : "",
        details.CleaningRate ? details.CleaningRate.split("-")[0] : "",
        details.Item +
          (details.CustomItem ? " (" + details.CustomItem + ")" : ""),
        details.Quantity,
        log.BagCount && log.Quantity
          ? parseInt(log.BagCount) * parseInt(log.Quantity)
          : "",
        (details.Supplier ? details.Supplier : "") +
          (details.CustomSupplier ? " (" + details.CustomSupplier + ")" : ""),
      ]);
    });
    //console.log(data, merges)

    var wb = XLSX.utils.book_new();
    var ws = XLSX.utils.aoa_to_sheet(data);
    ws["!merges"] = merges;
    XLSX.utils.book_append_sheet(
      wb,
      ws,
      formatDateOnly(store.date) +
        " " +
        store.workshift.value.replace(/\s/g, "")
    );

    XLSX.writeFile(
      wb,
      "Műszaknapló_" +
        formatDateOnly(store.date) +
        "_" +
        store.workshift.value.replace(/\s/g, "") +
        ".xlsx",
      { bookSST: true, compression: true }
    );
  }

  render() {
    const { store, configStore, route, router } = this.props;
    const { shownItems } = store;
    let { name: routeName, params: routeParams } = route;

    let rows = [];

    shownItems.forEach((log, index) => {
      const details = log.Details;
      rows.push(
        <tr key={index}>
          <td>{log.Timestamp.split(" ")[1]}</td>
          <td>{log.UserName}</td>
          <td>{details.Operation}</td>
          <td>
            {details.LotNo +
              (details.SealNum ? " (" + details.SealNum + ")" : "")}
          </td>
          <td>
            {details.Machine
              ? details.Machine + " x " + details.CleaningCount
              : ""}
          </td>
          <td>
            {details.CleaningRate ? details.CleaningRate.split("-")[0] : ""}
          </td>
          <td>
            {details.Item +
              (details.CustomItem ? " (" + details.CustomItem + ")" : "")}
          </td>
          <td>{details.Quantity}</td>
          <td>
            {(details.Supplier ? details.Supplier : "") +
              (details.CustomSupplier
                ? " (" + details.CustomSupplier + ")"
                : "")}
          </td>
        </tr>
      );
    });

    const cancelClassname =
      "search-cancel-button" + (store.search.length > 0 ? "" : " hidden");

    return (
      <Frame>
        <div className="workshift basic-content">
          <div className="workshift__top">
            <span className="workshift-filter-label">Dátum</span>
            <DatePicker
              className="table input-date form-input workshift-input"
              dateFormat="yyyy-MM-dd"
              selected={store.date}
              onChange={(date) => {
                console.log(date);
                store.setDate(date);
                this.refresh();
              }} /*locale='hu'*/
            />

            <span className="workshift-filter-label">Műszak</span>
            <Select
              className="react-select workshift-input"
              placeholder=""
              options={configStore.workshifts.map((workshift) => ({
                value: workshift,
                label: workshift,
              }))}
              onChange={(e) => {
                store.setWorkshift(e ? e : null);
                this.refresh();
              }}
              value={store.workshift}
              styles={SelectStyle}
              components={{ DropdownIndicator }}
            />

            <span className="workshift-filter-label">Szűrés</span>
            <div className="search-wrapper">
              <input
                className="search-input"
                value={store.search}
                onChange={(e) => store.setSearch(e.target.value)}
              />
              <div
                className={cancelClassname}
                onClick={(e) => store.setSearch("")}
              >
                <i className="fas fa-times"></i>
              </div>
            </div>

            <div
              id="workshift-download-button"
              onClick={() => this.handleDownload()}
            >
              Excel riport letöltés
            </div>
          </div>
          <div className="scroll-conatiner">
            <div className="workshift_content">
              <table id="workshift-table">
                <thead className="workshift-thead">
                  <tr>
                    <th>Időpont</th>
                    <th>Felhasználó</th>
                    <th>Művelet</th>
                    <th>Azonosító</th>
                    <th>Gép</th>
                    <th>Fok</th>
                    <th>Cikk</th>
                    <th>Mennyiség</th>
                    <th>Beszállító</th>
                  </tr>
                </thead>
                <tbody className="workshift-tbody">{rows}</tbody>
              </table>
            </div>
          </div>
        </div>
      </Frame>
    );
  }
}

export default (props) => (
  <RouteNode nodeName={ROUTE_WORKSHIFT}>
    {(routeProps) => <Workshift {...routeProps} {...props} />}
  </RouteNode>
);
